'use client';

import useBackend from '@/backend';
import { useGetUser } from '@/backend/user/get-user/get-user';
import { Wallet } from '@/backend/user/get-user/types';
import Notification_Toast_Primary from '@/components/Notifications/Notification_Toast_Primary/Notification_Toast_Primary';
import usePixelEvent from '@/features/usePixelEvent/usePixelEvent';
import {
	ModalStatusEnum,
	useAuthenticated,
	useModalStatus,
	useModalStoreActions,
	useNotificationsStoreActions,
	useUser,
	useUserStoreActions,
	useVipActions,
	useVipLevelUpData,
} from '@/store';
import { useEffect } from 'react';
import { io, Socket } from 'socket.io-client';
import { a } from 'vitest/dist/chunks/suite.BJU7kdY9.js';

const SocketLogger = () => {
	const { getUser } = useGetUser();
	const authenticated = useAuthenticated();
	const { getAccessToken } = useBackend();
	const { updateWallet } = useUserStoreActions();
	const { fireDepositPixel, fireFacebookPurchase } = usePixelEvent();
	const modalStatus = useModalStatus();
	const { setModalStatus } = useModalStoreActions();
	const user = useUser();
	const { addNotification } = useNotificationsStoreActions();
	const { setVipLevelUpData } = useVipActions();
	const vipLevelUpData = useVipLevelUpData();

	useEffect(() => {
		if (!user?.uniqueId) return;
		if (!authenticated) return;
		let socket: Socket;

		const connectSocket = async () => {
			const token = await getAccessToken({});
			if (!token) return;

			const formattedToken = token?.split('=')[1];

			if (!token) return;

			socket = io(`${process.env.NEXT_PUBLIC_USER_API_URL}/private`, {
				path: '/core/user-service/v1/socket',
				transports: ['websocket'],
				query: {
					'access-token': formattedToken,
				},
			});

			socket.on('connect', () => {});

			socket.onAny((event, ...args) => {
				if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'prod') {
					console.log(`Event~: ${event}`);
					// console.log(`Event~: ${event}`, args);
				}

				switch (event) {
					case 'wallet':
						try {
							const parsed =
								typeof args[0] === 'string' ? JSON.parse(args[0]) : args[0];
							updateWallet(parsed);
						} catch (err) {
							// console.error('Failed to parse wallet payload:', args[0], err);
						}
						break;
					case 'deposit':
						try {
							// const parsed =
							// 	typeof args[0] === 'string' ? JSON.parse(args[0]) : args[0];
							// updateWallet(parsed);

							if (modalStatus === ModalStatusEnum.WalletModal) {
								setModalStatus(null);
							}

							const depositData =
								typeof args[0] === 'string' ? JSON.parse(args[0]) : args[0];

							// {
							// 	amount: '0.1',
							// 	currency: 'LTCT',
							// 	transactionId: '079bb3bc-9152-4f4f-a052-fcb6fe6e89b5',
							// 	status: 'completed',
							// 	userId: 1421,
							// 	timestamp: '2025-05-13T18:50:11.200Z'
							//   }

							addNotification(({ id }) => (
								<Notification_Toast_Primary id={id}>
									<div className="flex flex-col gap-1  w-full">
										<p className="font-bold flex flex-col">
											Deposit Received!
											<span className=" font-normal teext-xs text-dove-white-o-90">
												Deposit History
											</span>
										</p>

										<div className="flex flex-col gap-1 ">
											<p className="flex items-center justify-between mt-1 text-xs w-full">
												<span>You deposited:</span>{' '}
												<span>
													{depositData?.amount} {depositData?.currency}
												</span>
											</p>
											{/* <p className="flex items-center justify-between mt-1 text-xs">
												Processed on network: <span>€40</span>
											</p> */}
										</div>
									</div>
								</Notification_Toast_Primary>
							));

							const userUniqueId = user?.uniqueId;

							if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'prod') {
								console.log(
									'Pixel deposit event fired',
									userUniqueId,
									depositData?.amount,
									depositData?.currency
								);
							}

							if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'prod') {
								if (userUniqueId) {
									fireDepositPixel({
										accountId: userUniqueId || '',
										depositValue: depositData?.amount || 0,
										currency: depositData?.currency || '',
									});

									fireFacebookPurchase({
										value: depositData?.amount || '0',
										currency: depositData?.currency || 'USD',
									});
								}
							}

							getUser({});
							// 							 {
							//     amount: '0.1',
							//     currency: 'LTCT',
							//     transactionId: '0cbb9199-7bc4-4795-9e50-a3689dfd4b6f',
							//     status: 'completed',
							//     userId: 1421,
							//     timestamp: '2025-05-12T22:28:58.398Z'
							//   }
						} catch (err) {
							// console.error('Failed to parse wallet payload:', args[0], err);
						}
						break;
					case 'bet':
						break;
					case 'exchange_bet':
						// console.log(args[0]);
						break;
					case 'withdraw':
						// console.log(args[0]);
						getUser({});
						break;
					case 'level_up':
						// console.log(args[0]);
						const data = args[0];
						const levelData = [...vipLevelUpData, data];
						if (levelData.length > 0) {
							setModalStatus(ModalStatusEnum.LevelUpModal);
							setVipLevelUpData([...vipLevelUpData, data]);
						}

						// {
						// 	"level": 3,
						// 	"tierName": "Owner",
						// 	"propertyName": "CONDO",
						// 	"pointsRequired": "1000.00",
						// 	"description": "A cozy unit within a shared building, offering both community and convenience.",
						// 	"imageUrl": "https://cdn.otherworld.xyz/public/assets/vip/vip-properties/condo.webp",
						// 	"bonuses": [
						// 		{
						// 			"type": "CASH_BONUS",
						// 			"depositBonus": null,
						// 			"cashBonus": {
						// 				"fiatAmount": "2.000000000000000000"
						// 			},
						// 			"freespinBonus": null
						// 		},
						// 		{
						// 			"type": "FREESPIN_BONUS",
						// 			"depositBonus": null,
						// 			"cashBonus": null,
						// 			"freespinBonus": {
						// 				"quantity": 5
						// 			}
						// 		}
						// 	]
						// }

						break;

					default:
						break;
				}
			});
		};

		connectSocket();

		return () => {
			socket?.disconnect();
		};
	}, [getAccessToken, authenticated, user?.uniqueId]);

	return null;
};

export default SocketLogger;
